import { render, staticRenderFns } from "./LoginBtn.vue?vue&type=template&id=4b333105&scoped=true&"
import script from "./LoginBtn.vue?vue&type=script&lang=js&"
export * from "./LoginBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b333105",
  null
  
)

export default component.exports